import { Purchase } from '@domain'

export enum ContractSummaryStatus {
	ALL = 'ALL',
	ACCEPTED = 'ACCEPTED',
	PENDING = 'PENDING',
	REJECTED = 'REJECTED',
}

export type ContractSummaryMatchTypeFilter = 'EXACT' | 'SIMILAR' | 'ALL'

export type ContractSummariesReq = {
	status?: ContractSummaryStatus
}

export type ContractSummaryDetailReq = {
	matchType?: ContractSummaryMatchTypeFilter
}

export type ContractLoadingSummary = {
	total: number
	accepted: number
	pending: number
	rejected: number
	acceptedAnnualTotalSavings: number
}

export type ContractSummary = {
	id: Id
	marketBasketId: Id
	termSetId: string
	termSetName: string
	topLevelCustomerName: string
	topLevelCustomerPlid: string
	manufacturerName: string
	manufacturerPlid: string
	onContract: boolean
	numProducts: number
	recommend: boolean
	requiresPriceImplementation: boolean
	directDealRejected: boolean
	status: ContractSummaryStatus
	annualPurchaseVolume: number
	dateRangePurchaseVolume: number
	annualPriceSavings: number
	dateRangePriceSavings: number
	dateRangePriceSavingsExact: number
	annualRebateSavings: number
	dateRangeRebateSavings: number
	dateRangeRebateSavingsExact: number
	annualTotalSavings: number
	dateRangeTotalSavings: number
	dateRangeTotalSavingsExact: number
	savingsPercentage: number
	createdAt: string | null
	updatedAt: string | null
}

export type ContractSummaryPurchaseCounts = {
	total: number
	exactMatches: number
	similarMatches: number
}

export type ContractSummaryDetail = {
	summary: ContractSummary
	purchases: Purchase[]
	purchaseCounts: ContractSummaryPurchaseCounts
}
